import React, { useState } from 'react';
import { Row } from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import HeroCard from '../HeroCard/HeroCard';
import ResponseInformation from './ResponseInformation';

export default function ExampleHeroCardResponse({ elem, reloadBotResponse, showFav }) {
  // console.log(elem);
  // console.log(reloadBotResponse)
  const [isAddMsg, setIsAddMsg] = useState(true);

  return (
    <Row>
      <Colxx xxs="12" xs="3">
        <ResponseInformation elem={elem} showFav={showFav} />
      </Colxx>
      <Colxx xxs="12" xs="9">
        {isAddMsg ? (
          <Row>
            <Colxx md="12" className="mb-2">
              <HeroCard
                isAdd={isAddMsg}
                code={elem.query.code}
                type={elem.response.type}
                msg={''}
                messages={elem.response.messages}
                index={0}
                example={elem.response.example}
                setIsAddMsgToFalse={() => setIsAddMsg(false)}
                reloadBotResponse={reloadBotResponse}
                Title={elem.query.title}
                SubTitle={elem.query.subTitle}
                AllButtons={elem.query.buttons}
                isEditAble={false}
                imageUrl={''}
                link={''}
              />
            </Colxx>
          </Row>
        ) : null}
      </Colxx>
    </Row>
  );
}
